<template>
    <section class="comp_bookings_home">
        <div class="comp_scroller">
            <div class="comp_content">
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <router-link v-for="item in menu" class="elm_nav_item" :to="item.url" :key="item.id">
                        <span>{{ $t(item.title) }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'bookings-home',
    data() {
        return {
            menu: [
                {
                    id: 0,
                    url: '/bookings/new',
                    title: 'new_booking'
                },
                {
                    id: 1,
                    url: '/bookings/overview',
                    title: 'bookings_overview'
                },
                {
                    id: 2,
                    url: '/bookings/channel',
                    title: 'channel_manager'
                },
                {
                    id: 3,
                    url: '/bookings/calendar',
                    title: 'channel_calendar'
                }
            ]
        }
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/bookings-home.vue